import { render, staticRenderFns } from "./Proyecto.vue?vue&type=template&id=1502f84e&"
import script from "./Proyecto.vue?vue&type=script&lang=js&"
export * from "./Proyecto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports